import StorageService from './storage';

export let LocalStorageApi: StorageService | null = null;

if (typeof window !== 'undefined' && window.localStorage) {
  LocalStorageApi = new StorageService(window.localStorage);
}

export { AuthAccessor } from './authAccessor';
